import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import "froala-editor/js/plugins/char_counter.min.js";
import "froala-editor/css/plugins/char_counter.min.css";

import "froala-editor/js/plugins/colors.min.js";
import "froala-editor/css/plugins/colors.min.css";

import "froala-editor/js/plugins/font_family.min.js";

import "froala-editor/js/plugins/font_size.min.js";

import "froala-editor/js/plugins/help.min.js";
import "froala-editor/css/plugins/help.min.css";

import "froala-editor/js/plugins/image.min.js";
import "froala-editor/css/plugins/image.min.css";

import "froala-editor/js/plugins/link.min.js";

import "froala-editor/js/plugins/table.min.js";
import "froala-editor/css/plugins/table.min.css";

import "froala-editor/js/plugins/word_paste.min.js";

import "froala-editor/js/plugins/lists.min.js";

import FroalaEditor from "react-froala-wysiwyg";
import React from "react";

const EDITOR_CONFIG = {
  attribution: false,
  key: process.env.REACT_APP_FROALA_KEY,
  charCounterCount: true,
  toolbarButtons: [
    "bold",
    "italic",
    "underline",
    "strikeThrough",
    "subscript",
    "superscript",
    "|",
    "fontFamily",
    "fontSize",
    "color",
    "|",
    "lineHeight",
    "formatOL",
    "formatUL",
    "|",
    "insertLink",
    "insertImage",
    "insertTable",
    "|",
    "spellChecker",
    "help",
    "|",
    "undo",
    "redo",
  ],
  tooltips: true,
  typingTimer: 500,
  quickInsertButtons: [],
  quickInsertTags: [],
  fontFamily: {
    "Arial,Helvetica,sans-serif": "Arial",
    "Georgia,serif": "Georgia",
    "'Times New Roman',Times,serif": "Times New Roman",
    "Verdana,Geneva,sans-serif": "Verdana",
  },
  fontFamilyDefaultSelection: "Arial",
  heightMin: 300,
  placeholderText: "",
  tabSpaces: 4,
  imageUploadURL: "https://api.cloudinary.com/v1_1/ofqual/image/upload",
  imageMaxSize: 5 * 1024 * 1024,
  imageUploadParams: {
    "X-Requested-With": "XMLHttpRequest",
    upload_preset: "Portal",
  },
  events: {
    "image.uploaded": function (response: any) {
      let self: any = this;
      const jsonResponse = JSON.parse(response);
      self.image.insert(
        jsonResponse.secure_url,
        true,
        null,
        self.image.get(),
        null
      );
      return false;
    },
    "image.error": function (error: any, response: any) {
      let err = error;
      let err2 = response;
      return false;
    },
  },
};

export type HtmlEditorProps = {
  value: string | null;
  onChange?: (value: string | null) => void;
  readOnly?: boolean;
};

export const HtmlEditor: React.FC<HtmlEditorProps> = ({
  value,
  onChange,
  readOnly = false,
}) => {
  return (
    <>
      <FroalaEditor
        tag="textarea"
        config={EDITOR_CONFIG}
        model={value}
        onModelChange={onChange}
      />
    </>
  );
};
